module.exports = __webpack_public_path__ + "static/media/sarah-win.4f5cd701.png";